<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-normal">Chi tiết tờ khai lúc {{ $helper.momentFormatLocale(data.created_at, 'DD/MM/YYYY HH:mm', 7) }}</span>
			</div>
			<div>
				<div class="p-6" v-if="data">
					<div>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Họ tên:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.hoten }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Năm sinh:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.namsinh }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Điện thoại:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.sdt }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Giới tính:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.gioitinh == '1' ? 'Nam' : 'Nữ' }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Tỉnh thành:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.tinh_data ? data.tinh_data.name : '-' }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Quận huyện:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.huyen_data ? data.huyen_data.name : '-' }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Phường xã:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.xa_data ? data.xa_data.name : '-' }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Địa chỉ nhà:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.noio }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Nơi làm việc/lưu trú trước khi tới Đồng Tháp:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.luutru ? data.luutru : '-' }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Các triệu chứng:</label></b>
							</vs-col>
						</vs-row>
						
						<vs-row class="mb-1" :key="indextr" v-for="(tr, indextr) in data.trieuchung">
							<vs-col vs-w="5">
								<label class="text-solid-gray-1"> - {{trieuchungs[indextr]}}:</label>
							</vs-col>
							<vs-col vs-w="7" class="text-black"><label :style="{color: tr == 'true' ? 'red' : '#4A4A4A'}">{{ tr == 'true' ? 'Có' : 'Không' }}</label></vs-col>
						</vs-row>

						<vs-row class="mb-2 mt-1">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Trực thuộc công ty:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ data.congty }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Thời gian làm việc tại công ty:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ $helper.locateWorkShift(data.ca) }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="12" v-if="data.status == 2">
								<b><label class="text-solid-gray-1">Lịch trình di chuyển trong ngày:</label></b>
							</vs-col>
							<vs-col vs-w="12" v-else>
								<b><label class="text-solid-gray-1">Tình trạng hiện tại:</label></b>
							</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="12" class="text-black"><pre style="white-space: pre-line;">{{ data.lichtrinh }}</pre></vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="12" v-if="data.status == 2">
								<b><label class="text-solid-gray-1">Người trong nhà đã đi những nơi nào hoặc từ nơi khác đến:</label></b>
							</vs-col>
							<vs-col vs-w="12" v-else>
								<b><label class="text-solid-gray-1">Hỗ trợ:</label></b>
							</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="12" class="text-black"><pre style="white-space: pre-line;">{{ data.lichtrinh2 ? data.lichtrinh2 : '-' }}</pre></vs-col>
						</vs-row>
						<vs-row class="mb-2" v-if="data.status == 0">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Lịch sử tiếp xúc:</label></b>
							</vs-col>
						</vs-row>
						<vs-row class="mb-2" v-if="data.status == 0">
							<vs-col vs-w="12" class="text-black"><pre style="white-space: pre-line;">{{ data.lichsu ? data.lichsu : '-' }}</pre></vs-col>
						</vs-row>
					</div>
				</div>

				<div class="px-6" v-if="histories && histories.length">
					<div slot="title" class="flex justify-between items-center w-full pb-4">
						<span class="el-dialog__title break-normal">Lịch sử khai báo:</span>
					</div>

					<div :key="indextr" v-for="(history, indextr) in histories" class="mb-4">
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Thời gian:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ $helper.momentFormatLocale(history.created_at, 'DD/MM/YYYY HH:mm', 7) }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Số phiếu:</label></b>
							</vs-col>
							<vs-col vs-w="7" class="text-black">{{ ('000000' + history.id).slice(-6) }}</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="5">
								<b><label class="text-solid-gray-1">Các triệu chứng:</label></b>
							</vs-col>
						</vs-row>
						
						<vs-row class="mb-1" :key="indextr2" v-for="(tr, indextr2) in history.trieuchung">
							<vs-col vs-w="5">
								<label class="text-solid-gray-1"> - {{trieuchungs[indextr2]}}:</label>
							</vs-col>
							<vs-col vs-w="7" class="text-black"><label :style="{color: tr == 'true' ? 'red' : '#4A4A4A'}">{{ tr == 'true' ? 'Có' : 'Không' }}</label></vs-col>
						</vs-row>

						<vs-row class="mb-2">
							<vs-col vs-w="12">
								<b><label class="text-solid-gray-1">Lịch trình di chuyển trong ngày:</label></b>
							</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="12" class="text-black"><pre style="white-space: pre-line;">{{ history.lichtrinh }}</pre></vs-col>
						</vs-row>

						<vs-row class="mb-2">
							<vs-col vs-w="12">
								<b><label class="text-solid-gray-1">Người trong nhà đã đi những nơi nào hoặc từ nơi khác đến:</label></b>
							</vs-col>
						</vs-row>
						<vs-row class="mb-2">
							<vs-col vs-w="12" class="text-black"><pre style="white-space: pre-line;">{{ history.lichtrinh2 ? history.lichtrinh2 : '-' }}</pre></vs-col>
						</vs-row>

						<hr />
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
const userDefaults = {
	ward: "",
	district: "",
	province: ""
};
export default {
	name: "UserDetail",
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {
			tabPosition: "all",
			trieuchungs: {
				'trieuchung-sot': 'Sốt',
				'trieuchung-ho': 'Ho, khó thở, tức ngực',
				'trieuchung-dh': 'Đau họng/ rát cổ',
				'trieuchung-mvg': 'Mất vị giác/ khứu giác đột ngột',
				'trieuchung-xhd': 'Nổi ban ngoài da/ Xuất huyết ngoài da',
			},
			histories: [],
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				console.log("Customer deiatal", this.data);

				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		}
	},
	watch: {
		tabPosition() {
			if (this.tabPosition === "ponds") {
				this.getCustomerPonds();
			}
		}
	},
	methods: {
		address() {
			let _address = this.data.address && this.data.address.street ? this.data.address.street + ", " : "";
			// Update property in user
			Object.keys(userDefaults).forEach(key => {
				// If property is defined in localStorage => Use that
				_address = _address + (this.data.address[key] && this.data.address[key] !== undefined && this.data.address[key].name !== "" ? this.data.address[key].name + ", " : "");
			});
			_address = _address.slice(0, _address.lastIndexOf(","));
			return _address;
		},
		async getCustomerPonds() {
			// this.$vs.loading();
			const customer = await  this.$store.dispatch("moduleCustomer/fetchCustomer", this.data.sdt);
			if (customer &&  customer.data) {
				if (Array.isArray(customer.data)) {
					customer.data.shift();
				}
				this.histories = customer.data;
			}
			// this.$vs.loading.close();
		}
	},
	created() {
		this.getCustomerPonds();
	},
};
</script>
<style lang="scss">
.el-radio-button__inner {
	width: 100%;
	border: none;
	border-radius: 0 0 0 0 !important;
}
[dir] .el-radio-button__inner {
	background: #e0e0e0;
}
</style>
